import { render, staticRenderFns } from "./CmgCheckoutCustomerPayment.vue?vue&type=template&id=2478cd49&scoped=true&lang=pug"
import script from "./cmg-checkout-customer-payment.ts?vue&type=script&lang=ts&external"
export * from "./cmg-checkout-customer-payment.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgCheckoutCustomerPayment.vue?vue&type=style&index=0&id=2478cd49&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2478cd49",
  null
  
)

export default component.exports